<div *ngIf="value || showZeroValue"
     [class.is-negative]="isNegativeNumber(value)">
    {{getAbs(value) | currency}}
</div>
<div class="is-empty" style="text-align: center" *ngIf="!value && !showZeroValue"></div>
